import { z } from 'zod';

// Validación del payload de "Enviar a remuneraciones" (diálogo de confirmación del listado).
// Refleja LC_SendMonthlyCutsToPayrollIn del backend: al menos un corte y, opcionalmente, un sistema
// destino válido. targetSystem es opcional; si se omite, el backend asume 'REX'.
export const PAYROLL_TARGET_SYSTEMS = ['REX'] as const;

export const sendMonthlyCutsToPayrollSchema = z.object({
  monthlyCutIds: z
    .array(z.number().int().positive())
    .min(1, 'attendance:monthlyCutsSendToPayroll.validation.cutsRequired'),
  targetSystem: z.enum(PAYROLL_TARGET_SYSTEMS).optional(),
});

export type SendMonthlyCutsToPayrollFormData = z.infer<typeof sendMonthlyCutsToPayrollSchema>;
